import { FormDialog } from "../../components/FormDialog/FormDialog";

const SystemDialog = ({ formId, saveSystemData, uiSchema, systemSchema, formData, handleFormChange, readOnly }) => {

    return (
        <FormDialog formId={formId}
            formData={formData}
            uiSchema={uiSchema}
            schema={systemSchema}
            handleFormChange={handleFormChange}
            readOnly={readOnly}
            saveFormData={saveSystemData}
        />
    );
}

export default SystemDialog;
